import { signupFormSchema } from "@redotech/redo-model/signup-form-schema";
import * as z from "zod/v4";

export const getEmbeddedFormsResponseSchema = z.array(
  z.object({
    id: z.string(),
    form: signupFormSchema,
    publishedAt: z.date().nullable(),
    merchantPhoneNumber: z.string().optional(),
  }),
);
export type GetEmbeddedFormsResponse = z.infer<
  typeof getEmbeddedFormsResponseSchema
>;

export const getEmbeddedForms = {
  name: "getEmbeddedForms" as const,
  input: z.object({}),
  output: getEmbeddedFormsResponseSchema,
};
